import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core'
import { GenericLinkModule, NavigationModule } from '@spartacus/storefront'
import { CustomFooterNavigationComponent } from './custom-footer-navigation.component'

@NgModule({
  imports: [CommonModule, RouterModule, NavigationModule, GenericLinkModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        FooterNavigationComponent: {
          component: CustomFooterNavigationComponent
        }
      }
    })
  ],
  declarations: [CustomFooterNavigationComponent],
  exports: [CustomFooterNavigationComponent]
})
export class CustomFooterNavigationModule {}
